module.exports = __webpack_public_path__ + "img/aqfh-img-15.1c1ad89e.png";